module.exports = __webpack_public_path__ + "img/Efdot - Slider 03.1a044cc4.jpg";